import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {

    const token = localStorage.getItem('jwt');
    const fName = localStorage.getItem('uFname');
    const lName = localStorage.getItem('uLname');
    const uid   = parseInt(localStorage.getItem('uid'));  // Ensure it's a number

    if (token && fName && lName && uid) {
      setUser({ first_name: fName, last_name: lName, id: uid });
      setIsAuthenticated(true);
      setLoading(false);
    } else {
      setLoading(false); // No token means not authenticated
    }

  }, []);

  const login = (jwt, activeUser) => {
    localStorage.setItem('jwt', jwt);
    localStorage.setItem('uid', activeUser.id);
    localStorage.setItem('uFname', activeUser.first_name);
    localStorage.setItem('uLname', activeUser.last_name);
    setUser(activeUser);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('jwt');
    localStorage.removeItem('uid');
    localStorage.removeItem('uFname');
    localStorage.removeItem('uLname');
    setUser({});
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
